import React from 'react';
import * as classes from './contentHeader.module.css';

export default function ContentHeader({ template, featuredImage }) {
  const { node: { altText = '', mediaItemUrl = '' } = {} } =
    featuredImage || {};
  let mainImg = null;

  if (template === '0') {
    mainImg = (
      <div className={classes.main_img}>
        <img
          src={
            mediaItemUrl ||
            'https://www.zomato.com/blog/wp-content/uploads/2021/07/cover-future-1024x674.png'
          }
          className={`${classes.img} animate`}
          alt={altText || 'blog'}
        />

        <div className={classes.top_logos}>
          <a
            href={process.env.GATSBY_BASE_URL}
            className={classes.top_logos_link}
          >
            <img
              className={classes.main_logo_1}
              src="https://b.zmtcdn.com/data/o2_assets/285128a4a64440769031732d3aa613b91677662488.png"
              alt="Feeding India Logo"
            />
          </a>
        </div>
      </div>
    );
  } else {
    mainImg = (
      <div className={classes.main_img}>
        <img
          alt={altText || 'blog'}
          src={
            mediaItemUrl ||
            'https://www.zomato.com/blog/wp-content/uploads/2021/07/cover-future-1024x674.png'
          }
          className={`${classes.img} animate`}
        />
      </div>
    );
  }

  return <>{mainImg}</>;
}
